// src/helpers/purchaseModuleData.svelte.ts
import { usePersistedState } from "./usePersistedState.svelte";
import { DEFAULT_PURCHASE_FLOW_TYPE } from "./types";
export function createPurchaseModuleData() {
    const url = new URL(window.location.href);
    // --- Persisted fields (shared sk:* keys with purchaseFlowData) ---
    const _estimation = usePersistedState("sk:estimation", 0);
    const _zipCode = usePersistedState("sk:zipCode", "");
    const _residenceType = usePersistedState("sk:residenceType", undefined);
    const _selectedProductId = usePersistedState("sk:selectedProductId", null);
    // --- Session-only fields ---
    let _facilityInformationExtras = $state({});
    let selectedProductTypeId = $state(null);
    let productType = $state(undefined);
    let startDates = $state([]);
    let campaign = $state("");
    // No URL-param override here (unlike the default/moving flows); the module
    // follows the global default, revert by flipping DEFAULT_PURCHASE_FLOW_TYPE.
    let purchaseFlowType = $state(DEFAULT_PURCHASE_FLOW_TYPE);
    let forceShowEstimation = $state(false);
    // --- URL param pre-population ---
    // Mirrors the init block in the old apps/PurchaseModule.svelte. The xstate
    // version called updateStorage({ residenceType: "house" }) unconditionally —
    // that bug is dropped here; we persist the actually computed type.
    const forbrukningParam = url.searchParams.get("forbrukning");
    const postnrParam = url.searchParams.get("postnr");
    if (forbrukningParam && postnrParam) {
        _estimation.value = +forbrukningParam;
        _zipCode.value = postnrParam;
        _residenceType.value = _estimation.value < 7500 ? "apartment" : "house";
        forceShowEstimation = true;
    }
    // --- Helpers ---
    function canSkipEstimation() {
        return (_estimation.value > 0 &&
            !!_zipCode.value &&
            (_residenceType.value === "apartment" || _residenceType.value === "house"));
    }
    // --- Setters (persisted) ---
    function setEstimation(v) {
        _estimation.value = v;
    }
    function setZipCode(v) {
        _zipCode.value = v;
    }
    function setResidenceType(v) {
        _residenceType.value = v;
    }
    function setFacilityInformation(info) {
        const { zipcode, residenceType, ...rest } = info;
        if (zipcode !== undefined)
            _zipCode.value = zipcode;
        if (residenceType !== undefined)
            _residenceType.value = residenceType;
        _facilityInformationExtras = rest;
    }
    // --- Setters (session-only) ---
    function setProductId(v) {
        _selectedProductId.value = v;
    }
    function setProductTypeId(v) {
        selectedProductTypeId = v;
    }
    function setProductType(v) {
        productType = v;
    }
    function setStartDates(v) {
        startDates = v;
    }
    function setCampaign(v) {
        campaign = v;
    }
    return {
        // Persisted getters
        get estimation() { return _estimation.value; },
        get zipCode() { return _zipCode.value; },
        get residenceType() { return _residenceType.value; },
        get facilityInformation() {
            return {
                ..._facilityInformationExtras,
                zipcode: _zipCode.value,
                residenceType: _residenceType.value,
            };
        },
        // Session-only getters
        get selectedProductId() { return _selectedProductId.value; },
        get selectedProductTypeId() { return selectedProductTypeId; },
        get productType() { return productType; },
        get startDates() { return startDates; },
        get campaign() { return campaign; },
        get purchaseFlowType() { return purchaseFlowType; },
        get forceShowEstimation() { return forceShowEstimation; },
        // Helper
        canSkipEstimation,
        // Setters
        setEstimation,
        setZipCode,
        setResidenceType,
        setFacilityInformation,
        setProductId,
        setProductTypeId,
        setProductType,
        setStartDates,
        setCampaign,
    };
}
